var render, staticRenderFns
import script from "./baseTable.vue?vue&type=script&lang=js&"
export * from "./baseTable.vue?vue&type=script&lang=js&"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=1aed24a4&prod&lang=css&"
import style1 from "./baseTable.vue?vue&type=style&index=1&id=1aed24a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed24a4",
  null
  
)

export default component.exports